module.exports = __webpack_public_path__ + "static/img/195_TO8_2094_og.f49f288.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/195_TO8_2094_og.jpg
// module id = N5Pb
// module chunks = 0